import { atom } from 'recoil';

type IRoutes =
  | 'chooseTemplate'
  | 'setupReport'
  | 'moreSetting'
  | 'review'
  | 'sheetSuccess';

export const ReportNavigateState = atom<IRoutes>({
  key: 'report-navigate',
  default: 'chooseTemplate',
});

export const IsDisableSetupNextButtonState = atom<boolean>({
  key: 'is-disable-setup-next-button',
  default: false,
});
